<template>
    <div
        class="flex flex-col items-center p-4 shadow-md rounded-md border-none bg-white w-full"
    >
        <slot />
    </div>
</template>
<script setup></script>
<style lang="scss" scoped></style>
